import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { TicketRequest } from '../model/ticket-access-request.model';
import { SPT } from '../model/spt.model';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';

@Injectable({
  providedIn: 'root'
})

export class SPTService {

  constructor(private utilities: UtilitiesService) { }

  requestSPTAccess(body): Observable<GetAllResponse<SPT>> {
    const url = environment.portalURL + API_URL.SPT_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<SPT>>(url, body);
  }

  getRequestSPTAccess(id): Observable<GetAllResponse<SPT>> {
    const url = environment.portalURL + API_URL.SPT_REQUEST_URL + `/${id}`;
    return this.utilities.req.httpGet<GetAllResponse<SPT>>(url);
  }

  getRequestSPTAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.SPT_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

}
